module.exports = __webpack_public_path__ + "static/media/calendar.2530f34c.svg";